import { REDUCER_NAME } from './const'

import Analytics from '../../analytics'
import Customer from '../../customer'
import Email from '../../email'
import Lead from '../../lead'
import SalesOrder from '../../sales-order'
import Process from '../../process'
import Prospect from '../../prospect'
import Treatment from '../../treatment'
import Voucher from '../../voucher'
import { selectIsFetchingAppointment } from '../../appointment/state/selector'

export const selectIsFetching = state => {
    return (
        Analytics.selector.selectIsFetching(state) ||
        selectIsFetchingAppointment(state) ||
        Customer.selector.selectIsFetching(state) ||
        Email.selector.selectIsFetching(state) ||
        Lead.selector.selectIsFetching(state) ||
        SalesOrder.selector.selectIsFetching(state) ||
        Process.selector.selectIsFetching(state) ||
        Prospect.selector.selectIsFetching(state) ||
        Treatment.selector.selectIsFetching(state) ||
        Voucher.selector.selectIsFetching(state)
    )
}

export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}

export const selectIsNavigationCollapsed = (state) => {
    return selectOwnState(state).isNavigationCollapsed
}

export const selectIsTablet = state => {
    return selectOwnState(state).isTablet
}



// WEBPACK FOOTER //
// ./src/modules/layout/state/selector.js